import { filtersActions } from '../../../../redux/actions'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks'

import './ComplianceOptions.scss'
import Checkbox, { type CheckboxChangeEvent } from '../../../UI/checkbox/Checkbox'

const baseClass = 'compliance-options-tm'

const ComplianceOptionsTM = () => {
  const dispatch = useAppDispatch()
  const trainingMatrixFilters = useAppSelector(state => state.trainingMatrixFilters)

  const toggleShowOverallCompliancePercentage = (selection?: CheckboxChangeEvent) => {
    dispatch(filtersActions.setShowOverallCompliancePercentage(selection?.checked ?? false))
  }
  const toggleShowPercentageOfComplianceForIndividuals = (selection?: CheckboxChangeEvent) => {
    dispatch(filtersActions.setShowPercentageOfComplianceForIndividuals(selection?.checked ?? false))
  }
  const toggleShowPercentageOfComplianceForCompetencies = (selection?: CheckboxChangeEvent) => {
    dispatch(filtersActions.setShowPercentageOfComplianceForCompetencies(selection?.checked ?? false))
  }
  const toggleShowPercentageOfComplianceForGroups = (selection?: CheckboxChangeEvent) => {
    dispatch(filtersActions.setShowPercentageOfComplianceForGroups(selection?.checked ?? false))
  }

  return (
    <div className={`${baseClass}__root`}>
      <Checkbox
        name='showOverallCompliancePercentage'
        onChange={toggleShowOverallCompliancePercentage}
        checked={trainingMatrixFilters.showOverallCompliancePercentage}
        label='Show Overall Percentage of Compliance'
      />
      <Checkbox
        name='showPercentageOfComplianceForIndividuals'
        onChange={toggleShowPercentageOfComplianceForIndividuals}
        checked={trainingMatrixFilters.showPercentageOfComplianceForIndividuals}
        label='Show Percentage of Compliance for Individuals'
      />
      <Checkbox
        name='showPercentageOfComplianceForCompetencies'
        onChange={toggleShowPercentageOfComplianceForCompetencies}
        checked={trainingMatrixFilters.showPercentageOfComplianceForCompetencies}
        label='Show Percentage of Compliance for Competencies'
      />
      <Checkbox
        name='showPercentageOfComplianceForGroups'
        onChange={toggleShowPercentageOfComplianceForGroups}
        checked={trainingMatrixFilters.showPercentageOfComplianceForGroups}
        label='Show Percentage of Compliance for Competency Groups'
      />
    </div>
  )
}

export default ComplianceOptionsTM
